import React from 'react';

import { Platform } from 'react-native';

import { StaticImage, StaticImages } from 'components/picture/static-image';

export const StoreLocatorLoader = () => {
  return (
    <StaticImage
      alt="Store locator loading"
      style={{
        // for some reason this is needed for it to look right
        [Platform.OS === 'web' ? 'width' : 'height']: 100,
      }}
      source={StaticImages.StoreLocatorLoader}
    />
  );
};
